// src/components/Profile.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './Start.css';

const Profile = ({ setUser }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [company, setCompany] = useState('');
  const [department, setDepartment] = useState('');
  const [postalCode, setPostalCode] = useState('');
  const [address, setAddress] = useState('');
  const [phone, setPhone] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (!token) {
      navigate('/');
      return;
    }
    // 获取用户信息（只用于展示 email）
    const fetchUser = async () => {
      const response = await fetch('https://api.nagae.biz/api/users/me', {
        headers: { 'Authorization': `Bearer ${token}` },
      });
      if (response.ok) {
        const data = await response.json();
        setEmail(data.email);
      }
    };

    // 获取当前用户的基本信息
    const fetchBasicinfo = async () => {
      const response = await fetch('https://api.nagae.biz/api/basicinfo', {
        headers: { 'Authorization': `Bearer ${token}` },
      });
      if (response.ok) {
        const data = await response.json();
        setName(data.name || '');
        setCompany(data.company || '');
        setDepartment(data.department || '');
        setPostalCode(data.postal_code || '');
        setAddress(data.address || '');
        setPhone(data.phone || '');
      }
    };

    fetchUser();
    fetchBasicinfo();
  }, [navigate]);

  // 更新基本信息
  const handleUpdate = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('access_token');
    const response = await fetch('https://api.nagae.biz/api/basicinfo', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({
        name,
        company,
        department,
        postal_code: postalCode,
        address,
        phone,
      }),
    });
    if (response.ok) {
      alert('個人情報更新完了');
    } else {
      alert('個人情報更新エラー');
    }
  };

  // 退出登录
  const handleLogout = () => {
    localStorage.removeItem('access_token');
    setUser(null);
    navigate('/');
  };

  // 返回上一步
  const handleReturn = () => {
    navigate(-1);
  };

  // 删除账户
  const handleDeleteAccount = async () => {
    if (window.confirm('ご確認ください。')) {
      const token = localStorage.getItem('access_token');
      const response = await fetch('https://api.nagae.biz/api/users/me', {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      if (response.ok) {
        localStorage.removeItem('access_token');
        setUser(null);
        navigate('/');
      }
    }
  };

  return (
    <div className="app-container">
      <Helmet>
        <link
          href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@300;400;500;700&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      <header className="header">
        <div className="logo">
          <h1></h1>
          <p className="subtitle" style={{ marginBottom: '10px' }}></p>
        </div>
      </header>
      <main className="main-content">
        <section id="profile-screen" className="screen active">
          {/* 使用与 BasicInfoForm 类似的卡片布局 */}
          <div 
            className="card" 
            style={{
              maxWidth: '750px',
              marginTop: '-100px',
              margin: '-100px auto 0',
              position: 'relative',
              paddingBottom: '80px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}
          >
            <h2 className="section-title" style={{ textAlign: 'center', width: '100%' }}>個人情報</h2>
            <form 
              onSubmit={handleUpdate} 
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '15px',
                width: '100%'
              }}
            >
              <div className="form-group">
                <label className="inputLabel">名前：</label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="form-input"
                  placeholder="山田 太郎"
                  style={{ width: '100%', boxSizing: 'border-box' }}
                />
              </div>
              <div className="form-group">
                <label className="inputLabel">会社名：</label>
                <input
                  type="text"
                  value={company}
                  onChange={(e) => setCompany(e.target.value)}
                  className="form-input"
                  placeholder="株式会社サンプル"
                  style={{ width: '100%', boxSizing: 'border-box' }}
                />
              </div>
              <div className="form-group">
                <label className="inputLabel">部署：</label>
                <input
                  type="text"
                  value={department}
                  onChange={(e) => setDepartment(e.target.value)}
                  className="form-input"
                  placeholder="営業部"
                  style={{ width: '100%', boxSizing: 'border-box' }}
                />
              </div>
              <div className="form-group">
                <label className="inputLabel">郵便番号：</label>
                <input
                  type="text"
                  value={postalCode}
                  onChange={(e) => setPostalCode(e.target.value)}
                  className="form-input"
                  placeholder="123-4567"
                  style={{ width: '100%', boxSizing: 'border-box' }}
                />
              </div>
              <div className="form-group">
                <label className="inputLabel">ご住所：</label>
                <input
                  type="text"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  className="form-input"
                  placeholder="東京都千代田区1-2-3"
                  style={{ width: '100%', boxSizing: 'border-box' }}
                />
              </div>
              <div className="form-group">
                <label className="inputLabel">電話番号：</label>
                <input
                  type="text"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  className="form-input"
                  placeholder="03-1234-5678"
                  style={{ width: '100%', boxSizing: 'border-box' }}
                />
              </div>
            </form>
            <hr style={{ width: '100%', margin: '20px 0', marginTop: '50px'}} />
            <div 
              style={{ display: 'flex', justifyContent: 'space-between', width: '100%' , marginTop: '50px'}}
            >
              <button onClick={handleReturn} className="btn btn-secondary">
                戻る
              </button>
              <button onClick={handleUpdate} className="btn btn-primary">
                個人情報更新
              </button>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Profile;
